import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Recommend from "../pages/recommend/page";
import Avoid from "../pages/avoid/page";
import Order from "../pages/order/page";
import Review from "../pages/review/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/recommend",
    element: <Recommend />,
  },
  {
    path: "/avoid",
    element: <Avoid />,
  },
  {
    path: "/order",
    element: <Order />,
  },
  {
    path: "/review",
    element: <Review />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;